define('home/views/common/DiscussionCoverBaseView',[
    'backbone-marionette',

    'core/strings',
    'core/bus',

    'home/models/Session',

    'home/views/DiscussionBannerView',
    'home/views/DiscussionCoverActionsView',
    'home/views/TopicTagCollectionView',
    'home/mixins/withLoginOverlay',
    'home/mixins/withTruncate',
    'home/mixins/withSubviews',
], function (
    Marionette,

    strings,
    bus,

    Session,

    DiscussionBannerView,
    DiscussionCoverActionsView,
    TopicTagCollectionView,
    withLoginOverlay,
    withTruncate,
    withSubviews
) {
    'use strict';

    var parent = Marionette.ItemView;
    var gettext = strings.get;

    // Not intended to be instantiated. Should be subclassed.
    var DiscussionCoverBaseView = parent.extend({
        events: {
            'click [data-role=message] a': 'trackClickLink',
        },

        trackClickLink: function (evt) {
            bus.trigger('uiAction:clickLink', evt, {
                adjective: 'message',
            });
        },

        templateHelpers: function () {
            var thread = this.model.thread;
            var channel = this.model.channel;

            return {
                relativeTime: thread.getRelativeCreatedAt(),
                channel: channel && channel.toJSON(),
                image: thread.getImage(),
                discussionRoute: thread.getDiscussionRoute(this.channel),
            };
        },

        initialize: function (options) {
            this.app = options.app;
            this.session = Session.get();

            this.channel = this.model.channel;
            if (this.channel)
                // If channel is passed as an option, it it likely specified because it is not
                // fetchable as part of the forum, so it will require a separate fetch and
                // will need a rerender once fetched.
                this.listenTo(this.channel, 'change', this.render);

            this.listenTo(this.model.thread, {
                'sync': this.render,
                'change:extending': this.render,
            });
        },

        regions: {
            bannerRegion: '[data-role=banner]',
            topicsRegion: '[data-role=topics]',
            threadActionsRegion: '[data-role=thread-actions]',
        },

        onRender: function () {
            var channel = this.model.channel;
            if (channel) {
                this.activateRegion(this.bannerRegion, this.createBanner);
                this.activateRegion(this.topicsRegion, this.createTopicsView);
            }

            this.activateRegion(this.threadActionsRegion, this.createThreadActions);
        },

        createBanner: function () {
            return new DiscussionBannerView({
                model: this.model.channel,
                app: this.app,
                session: this.session,
            });
        },

        createThreadActions: function () {
            return new DiscussionCoverActionsView({
                el: this.threadActionsRegion.el,
                model: this.model.thread,
                channel: this.model.channel,
            });
        },

        createTopicsView: function () {
            var topics = this.model.thread.topics;
            var channel = this.model.channel;

            return new TopicTagCollectionView({
                collection: topics,
                channel: channel,
            });
        },
    });

    var proto = DiscussionCoverBaseView.prototype;
    withLoginOverlay.call(proto,
        strings.interpolate(
            gettext('Join %(disqus)s to discover more great discussions like these.'),
            { disqus: 'Disqus' }
        ));
    withTruncate.call(proto);
    withSubviews.call(proto);

    return DiscussionCoverBaseView;
});

